var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["HotModuleReplacementPlugin"]: () => __WEBPACK_EXTERNAL_MODULE_webpack__.HotModuleReplacementPlugin, ["default"]: () => __WEBPACK_EXTERNAL_MODULE_webpack__["default"] });